import { render } from "./AgentPropertiesPagableList.vue?vue&type=template&id=5b3fabb0"
import script from "./AgentPropertiesPagableList.vue?vue&type=script&lang=js"
export * from "./AgentPropertiesPagableList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__